import { getStoreGuideItem } from './determineAdEligibility';

export default function determineSponsorshipEnabled(guideId) {
  return (state) => {
    const guideItem = getStoreGuideItem(guideId, state);

    return guideItem?.metadata?.properties?.ads?.sponsorshipEnabled ?? false;
  };
}
